/* global axios */
import ApiClient from '../ApiClient';

class PaymentsAPI extends ApiClient {
  constructor() {
    super('omni', { accountScoped: true });
  }

  // Orders
  getOrders(accountId, params = {}) {
    return axios.get(`${this.apiVersion}/accounts/${accountId}/omni/orders`, {
      params,
    });
  }

  getOrder(accountId, uuid) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/omni/orders/${uuid}`
    );
  }

  createOrder(accountId, data) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/orders`,
      data
    );
  }

  checkout(accountId, uuid, data) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/orders/${uuid}/checkout`,
      data
    );
  }

  cancelOrder(accountId, uuid) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/orders/${uuid}/cancel`
    );
  }

  refundOrder(accountId, uuid) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/orders/${uuid}/refund`
    );
  }

  // Ledger
  getLedger(accountId, params = {}) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/omni/ledger`,
      { params }
    );
  }

  getLedgerSummary(accountId, params = {}) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/omni/ledger/summary`,
      { params }
    );
  }

  // Payment Accounts
  getPaymentAccounts(accountId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts`
    );
  }

  connectStripe(accountId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts`,
      { provider: 'stripe_connect' }
    );
  }

  connectEfi(accountId, credentials) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts`,
      { provider: 'efi', ...credentials }
    );
  }

  getOnboardingLink(accountId, paymentAccountId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts/${paymentAccountId}/onboarding_link`
    );
  }

  getPaymentAccountStatus(accountId, paymentAccountId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts/${paymentAccountId}/status`
    );
  }

  disconnectPaymentAccount(accountId, paymentAccountId) {
    return axios.delete(
      `${this.apiVersion}/accounts/${accountId}/omni/payment_accounts/${paymentAccountId}`
    );
  }
}

export default new PaymentsAPI();
